
import TiwiMixin from '../../mixins/TiwiMixin';

import "tinymce/tinymce";
import "tinymce/themes/silver";
import "tinymce/icons/default";
import "tinymce/models/dom/model";
import "tinymce/plugins/autoresize";
// import "../../../mce-theme/theme"
// import "tinymce/skins/ui/oxide/skin.css";

import Editor from '@tinymce/tinymce-vue'
import { isError } from 'lodash';

export default {
  mixins: [TiwiMixin],
  components: {
    Editor
  },
  props: {
    block: {
      required: false,
      default: false,
      type: Object
    },
    onUpdate: {
      required: false,
      default: false
    },
    onDelete: {
      required: false,
      default: false
    },
    isError: {
      required: false,
      default: false
    },
  },
  mounted: function () {
    if (this.block.newBlock) {
      this.block.innerContent = [''];
      this.block.innerHTML = '';
      this.block.innerBlocks = {};
      this.block.attrs = {};

      if (this.block.blockName == 'core/image') {
        this.block.attrs = { id: null, linkDestination: 'none', sizeSlug: 'large' };
      }

      delete this.block.newBlock;
    }

    this.content = this.block.innerContent[0];
  },
  data() {
    return {
      content: null,
      image_url: this.block.attrs?.image_url
    }
  },
  methods: {
    onTinyChange: function () {
      this.block.innerHTML = this.content;
      this.block.innerContent = [`\n${this.content}\n`];
      this.onUpdate(this.block);
    },
    deleteBlock: function () {
      this.onDelete(this.block);
    },
    handleFileChange(e) {
      const selected_image = e.target.files[0];
      this.setLoading(true);

      const self = this;
      this.uploadMedia(selected_image, function (response) {
        const img_html = `<figure class="wp-block-image size-large"><img src="${response.data.attachment_url}" alt="" class="wp-image-${response.data.media_id}" /></figure>`
        self.block.innerHTML = img_html;
        self.block.innerContent = [`\n${img_html}\n`];
        self.block.attrs.id = response.data.media_id;
        self.image_url = response.data.attachment_url;
        self.onUpdate(self.block);
      }, () => {
        self.toast.error('Immagine non caricata: la dimensione massima è di '+ this.config.max_upload_size);
      }, () => {
        self.setLoading(false);
      }, this.block.attrs.id);
    }
  }
}
